var React = require('react');

function EdgeInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M-0.00012207 42L1400 0V42H-0.00012207Z"}));
}

EdgeInline.defaultProps = {"width":"1400","height":"42","viewBox":"0 0 1400 42","fill":"none"};

module.exports = EdgeInline;

EdgeInline.default = EdgeInline;
